import { type ElementType } from "react";
import type { IconType } from "react-icons";
import {
  Box,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { usePartnerTasks } from "hooks/usePartnerTasks";
import { formatCurrency } from "utils/formatCurrency";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { Mark } from "components/icons/Mark";
import {
  MdBarChart,
  MdLocalShipping,
  MdCheckCircle,
  MdPending,
  MdInventory,
} from "react-icons/md";
import TotalSpent from "./components/TotalSpent";
import PieCard from "./components/PieCard";
import AreaTrendCard from "./components/AreaTrendCard";

export default function Dashboard() {
  const { tasks, wineSalesMonthly, loading } = usePartnerTasks();
  const iconBg = useColorModeValue("brand.50", "brand.muted");
  
  const counts = {
    new: tasks.filter((t) => t.status === "new").length,
    preparing: tasks.filter((t) => t.status === "preparing").length,
    shipped: tasks.filter((t) => t.status === "shipped").length,
    delivered: tasks.filter((t) => t.status === "delivered").length,
  };

  const totalSold = tasks
    .filter((t) => t.status !== "cancelled")
    .reduce((sum, t) => sum + t.subtotal, 0);

  const statIcon = (Ico: ElementType | IconType) => (
    <IconBox
      w="56px"
      h="56px"
      bg={iconBg}
      icon={<Mark as={Ico} w="28px" h="28px" color="brand.500" />}
    />
  );

  return (
    <Box>
      <Box mb={6}>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 3 }} gap={5} mb={8}>
        <MiniStatistics
          startContent={statIcon(MdPending)}
          name="Pendentes"
          value={String(counts.new)}
        />
        <MiniStatistics
          startContent={statIcon(MdInventory)}
          name="Em separação"
          value={String(counts.preparing)}
        />
        <MiniStatistics
          startContent={statIcon(MdLocalShipping)}
          name="Enviados"
          value={String(counts.shipped)}
        />
        <MiniStatistics
          startContent={statIcon(MdCheckCircle)}
          name="Entregues"
          value={String(counts.delivered)}
        />
        <MiniStatistics
          startContent={statIcon(MdBarChart)}
          name="Total vendido"
          value={formatCurrency(totalSold)}
        />
      </SimpleGrid>

      <Box mt={10} mb={4}>
        <SimpleGrid columns={{ base: 1, lg: 2 }} gap={5} mb={5}>
          <TotalSpent
            totalSold={totalSold}
            wineSalesMonthly={wineSalesMonthly}
            loading={loading}
          />

          {/* Quais os tipos de vinho mais vendem? */}
          <PieCard
            wineSalesMonthly={wineSalesMonthly}
            loading={loading}
          />
        </SimpleGrid>
        <SimpleGrid columns={{ base: 1, lg: 1 }} gap={5} mb={5}>

          {/* <UserActivity /> */}
        </SimpleGrid>
        <AreaTrendCard wineSalesMonthly={wineSalesMonthly} loading={loading} />
      </Box>
    </Box>
  );
}
